<div class="price-summary-dialog">
    <div class="dialog-header">{{ 'CONFIGURATION.PANEL.LABEL.PRICE_OVERVIEW' | translate }}</div>
    <div class="dialog-prices">
        <div class="price-item">
            <div class="item-description">{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_GROSS' | translate }}:</div>
            <div class="item-price">
                {{ data.totalGross | currency : data.currency : 'symbol-narrow' }}
            </div>
        </div>
        <div class="price-item price-discount">
            <div class="item-description">{{ 'CONFIGURATION.PANEL.LABEL.PACKAGE_PRICE_ADVANTAGE' | translate }}:</div>
            <div class="item-price">
                {{ data.totalDiscount | currency : data.currency : 'symbol-narrow' }}
            </div>
        </div>
        <div class="price-item" *ngIf="data.totalDiscount && data.totalPrice">
            <div class="item-description">{{ 'CONFIGURATION.PANEL.LABEL.TOTAL_PRICE' | translate }}:</div>
            <div class="item-price">
                {{ data.totalPrice | currency : data.currency : 'symbol-narrow' }}
            </div>
        </div>
        <div class="price-item price-total">
            <div class="item-description">{{ 'CONFIGURATION.PANEL.LABEL.NET_PRICE' | translate }}:</div>
            <div class="item-price">
                {{ data.netPrice | currency : data.currency : 'symbol-narrow' }}
            </div>
        </div>
        <div class="price-item" *ngIf="data.voucherCode && data.voucherValue">
            <div class="item-description">
                {{
                    'OVERVIEW.TABLE.PRICE.OVERLAY.LABEL.VOUCHER'
                        | translate : { voucherCode: data.voucherCode.toLowerCase() }
                }}:
            </div>
            <div class="item-price">- {{ data.voucherValue | currency : data.currency : 'symbol-narrow' }}</div>
        </div>
    </div>
    <div class="dialog-infos">
        <div class="info-item" *ngIf="data.noPriceAdvantage">
            <mat-icon class="info-icon">info</mat-icon>
            <div class="item-description">
                {{ 'CONFIGURATION.PANEL.PRICE_TOOLTIP_NO_PRICE_ADVANTAGE' | translate }}
            </div>
        </div>
        <div class="info-item" *ngIf="data.voucherCode && (data.voucherValue || data.extraBonus)">
            <mat-icon class="info-icon">info</mat-icon>
            <div class="item-description">
                {{
                    'PRICE_SUMMARY.INFO_TEXT.VOUCHER.' + voucherTypeKey
                        | translate : { voucherCode: data.voucherCode.toLowerCase() }
                }}
                <ng-container *ngIf="data.voucherValue">
                    {{
                        'PRICE_SUMMARY.INFO_TEXT.VOUCHER.VOUCHER_VALUE.' + voucherTypeKey
                            | translate
                                : { voucherValue: data.voucherValue | currency : data.currency : 'symbol-narrow' }
                    }}
                </ng-container>
                <ng-container *ngIf="data.extraBonus">
                    {{
                        'PRICE_SUMMARY.INFO_TEXT.VOUCHER.EXTRA_BONUS'
                            | translate : { extraBonus: data.extraBonus | currency : data.currency : 'symbol-narrow' }
                    }}
                </ng-container>
            </div>
        </div>

        <div class="info-item" *ngIf="data.totalDiscount && data.totalPrice">
            <mat-icon class="info-icon">info</mat-icon>
            <div class="item-description">
                {{ 'PRICE_SUMMARY.INFO_TEXT.PRICE_ADVANTAGE' | translate }}
            </div>
        </div>

        <div class="info-item" *ngIf="partnerShopTranslationAvailable">
            <mat-icon class="info-icon">info</mat-icon>
            <div class="item-description">
                {{ 'PRICE_SUMMARY.INFO_TEXT.PARTNER_SHOP' | translate }}
            </div>
        </div>
    </div>
</div>
